import strFunc from "@/lib/lyg/string";

function SumMoneyArea(props: any) {
  let myProps = {
    countInfo: {},
    is_show_pay_money: true,
    ...props
  };
  let countInfo: any = {
    tot: 0,
    a_price_sum: 0,
    a_amount: 0,
    a_pay_money: 0,
    ...myProps.countInfo
  };

  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-2">
      <div className="flex items-center justify-end gap-4 text-sm">
        <div className="flex items-center gap-1">
          <span className="font-semibold text-gray-700">총합계:</span>
          <span className="font-bold text-blue-600">{countInfo.tot}건</span>
        </div>
        <div className="h-4 w-px bg-gray-300"></div>
        <div className="flex items-center gap-1">
          <span className="text-gray-600">주문금액:</span>
          <span className="font-semibold text-gray-900">{strFunc.comma(countInfo.a_price_sum)}원</span>
        </div>
        <div className="h-4 w-px bg-gray-300"></div>
        <div className="flex items-center gap-1">
          <span className="text-gray-600">주문수량:</span>
          <span className="font-semibold text-gray-900">{strFunc.comma(countInfo.a_amount)}개</span>
        </div>
        {myProps.is_show_pay_money &&
          <>
            <div className="h-4 w-px bg-gray-300"></div>
            <div className="flex items-center gap-1">
              <span className="text-gray-600">결제금액:</span>
              <span className="font-semibold text-red-600">{strFunc.comma(countInfo.a_pay_money)}원</span>
            </div>
          </>
        }
      </div>
    </div>
  );
};
export default SumMoneyArea;